<template>
  <main>
    <PolicyHeader/>
    <background-wrapper src="policy-footer" ext="png">
      <container-small class="py-6">
        <b-card>
          <h2 v-html="$t(`${$route.name}.body.title`)"/>
          <p v-html="$t(`${$route.name}.body.updated`)"/>
          <hr>
          <div v-html="$t(`${$route.name}.body.text`)"/>
        </b-card>
      </container-small>
    </background-wrapper>
  </main>
</template>

<script>
import { PolicyHeader } from '@/components/ui'
export default {
  name: 'Accessibility',
  components: {
    PolicyHeader
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/accessibility/Accessibility.vue